// ============================================================================
// USER BRANCH ACCESS ENDPOINTS
// ============================================================================

import { buildEndpoint, buildEndpointWithParams } from './base.endpoints';
import type { ID } from '../types';

const BASE_PATH = '/lmms/v1/user-access';

export const userAccessEndpoints = {
  list: () => buildEndpoint(BASE_PATH),
  myBranches: () => buildEndpoint(`${BASE_PATH}/my-branches`),
  usersLookup: () => buildEndpoint(`${BASE_PATH}/users-lookup`),
  assign: () => buildEndpoint(BASE_PATH),
  update: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
  revoke: (id: ID) => buildEndpointWithParams(`${BASE_PATH}/:id`, { id }),
} as const;

export default userAccessEndpoints;
